import React from "react";
import CatalogCollectionPage from "./CatalogCollectionPage";

export default function TimeImmersionPage() {
  return (
    <CatalogCollectionPage
      collectionKey="timeImmersion"
      eyebrow="Percorsi · TIME IMMERSION"
      title="TIME IMMERSION."
      description="Il percorso immersivo del progetto TIME. Contenuti in preparazione."
      testId="time-immersion"
    />
  );
}
